<div class="caption-bar">
  <div class="caption">{{ "settings.title" | translate }}</div>
</div>

<lib-settings></lib-settings>
